



import { useContext } from "react"
import { GlobalContext } from "../GlobalContext"
import Modal from "./Modal"
import Button from "../formfields/Button"
import Spinner from "./Spinner"
import { useVideo } from "../context/video/VideoContext"
import { useVoice } from "../context/voice/VoiceContext"

type Props = {
    showModal: ObjectStringKeyAnyValue
}


function MessageModal({
    showModal
}: Props) {

    const {
        setShowModal
    } = useContext(GlobalContext)

    const {
        finalSpokenAnswer
    } = useVoice()

    const isVoiceModal = showModal && (showModal["heardVoiceAnswer"] || (showModal["heardVoiceCommand"]))

    const isAnswerFinal = isVoiceModal && finalSpokenAnswer && finalSpokenAnswer === showModal["heardVoiceAnswer"]

    if (isVoiceModal) {
        return <div className={`z-50 fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/20 pointer-events-none p-4`}>

            <div className="rounded hover:opacity-90-xl w-full max-w-lg p-2 bg-white/80 divide-y divide-gray-500 shadow-2xl relative">


                {showModal["heardVoiceCommand"] && <div className={`w-full flex flex-row gap-2 items-center`}>
                    <p className={`text-6xl mb-2`}>👂</p>
                   <div className={`w-full flex flex-col gap-0 items-start`}>
                        <p className={`font-bold text-lg`}> Voice command recognised: </p>
                        <p className={`text-lg`}> {showModal["heardVoiceCommand"]}</p>
                        <p className={`text-sms`}> Available commands: 'save', 'note', 'capture', 'retake', 'back', 'reset'</p>
                    </div>
                </div>}


                {showModal["heardVoiceAnswer"] && !isAnswerFinal &&<div className={`w-full flex flex-row gap-2 items-center`}>
                    <div className={`px-2`}><Spinner/></div>
                   <div className={`w-full flex flex-col gap-0 items-start`}>
                        <p className={`font-bold text-lg`}>Listening to speech...</p>
                        {showModal["heardVoiceAnswer"] && <p className={`text-lg`}> {showModal["heardVoiceAnswer"]}</p>}
                    </div>
                </div>}

                {showModal["heardVoiceAnswer"] && isAnswerFinal &&<div className={`w-full flex flex-row gap-2 items-center`}>
                    <p className={`text-6xl mb-2`}>👂</p>
                   <div className={`w-full flex flex-col gap-0 items-start`}>
                        <p className={`font-bold text-lg`}> Speech recognised: </p>
                        <p className={`text-lg`}> {showModal["heardVoiceAnswer"]}</p>
                    </div>
                </div>}

            </div>
        </div>
    }




    return <Modal setShowModal={setShowModal} showCloseButton={true} closeButtonValue={null}>
        <div className={`w-full flex flex-col gap-4 items-center`}>

            {showModal["error"] && <div className={`w-full flex flex-col gap-2 items-center`}>
                <p className={`text-4xl`}>⛔️</p>
                <p className={``}>Error: {showModal["error"]}</p>
            </div>}

            {showModal["message"] && <div className={`w-full flex flex-col gap-2 items-center`}>
                <p className={`text-4xl`}>💬</p>
                <p className={``}>{showModal["message"]}</p>
            </div>}

            {showModal["success"] && <div className={`w-full flex flex-col gap-2 items-center`}>
                <p className={`text-4xl`}>✅</p>
                <p className={``}>{showModal["success"]}</p>
            </div>}

            {showModal["spinner"] && <div className={`w-full flex flex-col gap-2 items-center`}>
                <Spinner size="large">{showModal["spinner"]}</Spinner>
            </div>}



            {!showModal["spinner"] && !showModal["heardVoice"] && <Button
                onClick={() => setShowModal(null)}
                text={`OK`}
                variant={`primary`}
                size={`big`}
                fullwidth={true}
                id={`message-modal-ok-button`}
            />}
        </div>
    </Modal>
}

export default MessageModal